<template>
  <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
    <div
      v-for="unit in units"
      :key="unit.id"
      class="group relative bg-gradient-to-br from-gray-900 to-black border border-brand/20 rounded-3xl overflow-hidden hover:border-brand/60 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-brand/20"
    >
      <!-- Image Container -->
      <div class="relative h-64 overflow-hidden">
        <img
          :src="getImageUrl(unit.image)"
          :alt="unit.name"
          class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>

        <!-- Badge -->
        <div class="absolute top-4 left-4 px-3 py-1 bg-gradient-to-r from-brand to-brand-dark rounded-full">
          <span class="text-xs font-bold text-black">{{ unit.badge }}</span>
        </div>

        <!-- Size Badge -->
        <div class="absolute top-4 right-4 px-3 py-1 bg-black/80 backdrop-blur-md border border-brand/30 rounded-full">
          <span class="text-sm font-semibold text-brand">{{ unit.size }}</span>
        </div>
      </div>

      <!-- Content -->
      <div class="p-6">
        <div class="flex items-start justify-between mb-3">
          <div>
            <h3 class="text-2xl font-bold text-white mb-1 group-hover:text-brand transition-colors">
              {{ unit.name }}
            </h3>
            <p class="text-brand font-medium text-sm">{{ unit.type }}</p>
          </div>
        </div>

        <!-- Features Grid -->
        <div class="grid grid-cols-2 gap-2 mb-4">
          <div
            v-for="(feature, index) in unit.features.slice(0, 4)"
            :key="index"
            class="flex items-center gap-2 text-xs text-gray-400"
          >
            <svg class="w-3 h-3 text-brand flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
            <span>{{ feature }}</span>
          </div>
        </div>

        <!-- View More Features (Expandable) -->
        <div v-if="expandedUnit === unit.id" class="grid grid-cols-2 gap-2 mb-4">
          <div
            v-for="(feature, index) in unit.features.slice(4)"
            :key="index + 4"
            class="flex items-center gap-2 text-xs text-gray-400"
          >
            <svg class="w-3 h-3 text-brand flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
            <span>{{ feature }}</span>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center justify-between pt-4 border-t border-brand/20">
          <button
            @click="toggleExpand(unit.id)"
            class="text-sm text-gray-400 hover:text-brand transition-colors flex items-center gap-1"
          >
            {{ expandedUnit === unit.id ? 'Show Less' : 'Show More' }}
            <svg
              :class="['w-4 h-4 transition-transform', expandedUnit === unit.id ? 'rotate-180' : '']"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <button
            @click="$emit('view-details', unit)"
            class="flex items-center gap-2 text-brand font-semibold text-sm hover:text-brand-light transition-colors"
          >
            View Details
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { propertyUnits } from '@/data/properties';

export default {
  name: 'PropertyUnits',
  data() {
    return {
      units: propertyUnits,
      expandedUnit: null
    };
  },
  methods: {
    getImageUrl(imageName) {
      // Load images from assets/images folder
      try {
        return require(`@/assets/images/${imageName}`);
      } catch {
        // Fallback placeholder
        return 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop';
      }
    },
    toggleExpand(unitId) {
      this.expandedUnit = this.expandedUnit === unitId ? null : unitId;
    }
  }
};
</script>
